import { c as _c } from "react/compiler-runtime";
import { ImageCdn } from '@openclassrooms/images-cdn';
import Box from '@classify/react-core-components/Box';
import { useLocalisationConfig } from '@openclassrooms/localisation/LocalisationConfigProvider';
import { getButtonLinkProps, ROUTES } from '@openclassrooms/routing';
import { translate, getActiveLang } from '@openclassrooms/translations';
import { styled } from '@classify/react-core-components/styles';
import FooterSocialButtons from './FooterSocialButtons';
import appstoreEnImgSrc from './images/en/appstore.png';
import appstoreFrImgSrc from './images/fr/appstore.png';
import bcorpEnImgSrc from './images/en/b_corp.png';
import bcorpFrImgSrc from './images/fr/b_corp.png';
const StyledImageCdn = styled(ImageCdn)({
  maxWidth: '100%',
  height: 'auto'
}) as ImageCdn;
export default function FooterFollow() {
  const $ = _c(12);
  const {
    getLocalisationConfig
  } = useLocalisationConfig();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getActiveLang() === "fr" ? [appstoreFrImgSrc, bcorpFrImgSrc] : [appstoreEnImgSrc, bcorpEnImgSrc];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const images = t0;
  const [appstoreImgSrc, bcorpImgSrc] = images;
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      display: "flex",
      gap: {
        xs: 3,
        md: 4
      },
      flexDirection: "column"
    };
    t2 = <FooterSocialButtons />;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== getLocalisationConfig) {
    t3 = getLocalisationConfig("appstore.ios");
    $[3] = getLocalisationConfig;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = String(t3);
  let t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = translate("global.download.ios_app");
    t6 = <StyledImageCdn src={appstoreImgSrc} alt="" width="183" height="58" />;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t4) {
    t7 = <a href={t4} aria-label={t5}>{t6}</a>;
    $[7] = t4;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Box {...getButtonLinkProps(ROUTES.ABOUT_US.INDEX, {
      hash: "bcorp"
    })} aria-label={translate("global.bcorp-logo.label")}><StyledImageCdn src={bcorpImgSrc} alt="" width="216" height="100" /></Box>;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t7) {
    t9 = <Box sx={t1}>{t2}{t7}{t8}</Box>;
    $[10] = t7;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  return t9;
}